import styled from 'styled-components';

import AccordionSummary from '@mui/material/AccordionSummary';

export const TarifeWrapper = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 100vh;
`

export const Container = styled.div`
  position: relative;
  z-index: 3;

  margin: 0 16px;
`

export const AccordionSummaryWrapper = styled(AccordionSummary)`
  .MuiAccordionSummary-content {
    flex-direction: column;
  }
`